/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {LicenseUpdateRequest} from '../models/LicenseUpdateRequest';

export interface UpdateLicenseBaseInfo$Request {
    licenseId: number;
    licenseUpdateRequest: LicenseUpdateRequest;
}

export interface UpdateLicenseBaseInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateLicenseBaseInfoRequest = createAction<PayloadData<void, UpdateLicenseBaseInfo$Request>>('UPDATE_LICENSE_BASE_INFO__UPDATE_LICENSE_BASE_INFO__REQUEST');
export const updateLicenseBaseInfoSuccess = createAction<PayloadData<void, UpdateLicenseBaseInfo$Request>>('UPDATE_LICENSE_BASE_INFO__UPDATE_LICENSE_BASE_INFO__SUCCESS');
export const updateLicenseBaseInfoFailure = createAction<PayloadData<Error, UpdateLicenseBaseInfo$Request, true>>('UPDATE_LICENSE_BASE_INFO__UPDATE_LICENSE_BASE_INFO__FAILURE');

export const updateLicenseBaseInfoActions = [
    updateLicenseBaseInfoRequest,
    updateLicenseBaseInfoSuccess,
    updateLicenseBaseInfoFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {LicenseUpdateRequest} meta.licenseUpdateRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateLicenseBaseInfo = (meta: UpdateLicenseBaseInfo$Request, config?: UpdateLicenseBaseInfo$Config) => {
    return {
        CALL_API: {
            types: updateLicenseBaseInfoActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/licenses/base-info/${meta.licenseId}`,
            TRANSPORT_REQUEST_BODY: meta.licenseUpdateRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

